module.exports = __webpack_public_path__ + "img/live-room-show-overlay.99233f68.png";